export default __webpack_public_path__ + "static/media/638.f4b7dcbd.gif";